import { Injectable } from '@angular/core';
import { SettingsService } from '@common-modules/shared/config/settings.service';
import { BaseWorkerLoaderService } from './base-worker-loader.service';
import { InstanceUpdatesWorkerResponse } from './instance-updates-worker-response';
import { InstanceUpdatesWorkerParams } from './instance-updates.worker';

@Injectable()
export class InstanceUpdatesWorkerLoaderService extends BaseWorkerLoaderService<
  InstanceUpdatesWorkerParams,
  InstanceUpdatesWorkerResponse
> {
  constructor(private _settingsService: SettingsService) {
    super();
  }

  protected getWorker(): Worker {
    return new Worker(new URL('./instance-updates.worker.ts', import.meta.url), { type: 'module' });
  }

  protected emitInitializeWorker(): void {
    this.sendParams({
      initialize: {
        hubUrl: this.hubUrl,
      },
    });
  }

  private get hubUrl(): string {
    return `${this._settingsService.apis.default.url}/hub/cache`;
  }
}
